/* Robotspikes 2.0 – small vanilla helpers (no dependencies) */
(function () {
  // Finder: brand pills/select -> model select -> go to product
  document.querySelectorAll('[data-rs-finder]').forEach(function (root) {
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-rs-finder-data]').textContent); } catch (e) {}
    var brandSel = root.querySelector('[data-rs-brand]');
    var modelSel = root.querySelector('[data-rs-model]');
    var go = root.querySelector('[data-rs-go]');
    var result = root.querySelector('[data-rs-result]');
    var pills = root.querySelectorAll('[data-rs-brand-pill]');
    function fillModels(brand) {
      modelSel.innerHTML = '';
      var o = document.createElement('option'); o.value = ''; o.textContent = brand ? 'Vælg model' : 'Vælg først mærke'; modelSel.appendChild(o);
      data.filter(function (d) { return d.brand === brand; }).forEach(function (d) {
        var op = document.createElement('option'); op.value = d.url; op.textContent = d.model + (d.available ? '' : ' (udsolgt)'); op.dataset.available = d.available; modelSel.appendChild(op);
      });
      modelSel.disabled = !brand; go.disabled = true; if (result) result.textContent = '';
      pills.forEach(function (p) { p.setAttribute('aria-pressed', p.dataset.rsBrandPill === brand); });
    }
    brandSel.addEventListener('change', function () { fillModels(brandSel.value); });
    pills.forEach(function (p) { p.addEventListener('click', function () { brandSel.value = p.dataset.rsBrandPill; fillModels(p.dataset.rsBrandPill); modelSel.focus(); }); });
    modelSel.addEventListener('change', function () {
      go.disabled = !modelSel.value;
      if (result && modelSel.value) {
        var opt = modelSel.options[modelSel.selectedIndex];
        result.innerHTML = opt.dataset.available === 'true' ? '✓ Vi har spikes, der passer til <b>' + brandSel.value + ' ' + opt.textContent + '</b>.' : 'Spikes til denne model er midlertidigt udsolgt – tilmeld dig og få besked, når de er tilbage.';
      }
    });
    go.addEventListener('click', function () { if (modelSel.value) window.location.href = modelSel.value; });
  });

  // Delivery estimate: 1-3 business days (Mon-Fri) from today
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  document.querySelectorAll('[data-rs-delivery]').forEach(function (el) {
    var min = parseInt(el.dataset.min || '1', 10), max = parseInt(el.dataset.max || '3', 10);
    var f = { weekday: 'long', day: 'numeric', month: 'short' };
    var a = addBiz(new Date(), min).toLocaleDateString('da-DK', f), b = addBiz(new Date(), max).toLocaleDateString('da-DK', f);
    el.textContent = a + ' – ' + b;
  });

  // Free shipping progress (PDP and others outside the cart drawer)
  function money(c) { return (c / 100).toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr'; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function shipText(c, t) {
    var left = Math.max(t - c.total_price, 0);
    if (!c.item_count) return '<b>Fri fragt fra ' + Math.round(t / 100) + ' kr</b>';
    var sets = c.items.filter(function (i) { return String(i.variant_id) !== String(window.RS_DRILL_VARIANT || ''); });
    if (left > 0 && sets.length === 1 && sets[0].quantity === 1) {
      var it = sets[0];
      return 'Tilføj 1 sæt mere og få <b>fri fragt</b> <button type="button" class="rs-ship__add" data-rs-ship-add="' + it.variant_id + '">+ 1 sæt mere: ' + esc(it.product_title) + ' (' + money(it.final_price) + ')</button><small class="rs-ship__hint">Godt som backup – eller til robot nr. 2.</small>';
    }
    if (left > 0) return 'Du mangler <b>' + money(left) + '</b> for at få <b>fri fragt</b>';
    return 'Du har <b>fri fragt</b> ✓';
  }
  function updateShip(c) {
    document.querySelectorAll('[data-rs-ship]').forEach(function (el) {
      var t = parseInt(el.dataset.threshold, 10);
      var txt = el.querySelector('[data-rs-ship-text]'), bar = el.querySelector('[data-rs-ship-bar]');
      if (txt) txt.innerHTML = shipText(c, t);
      if (bar) bar.style.width = Math.min(100, (c.total_price / t) * 100) + '%';
    });
  }
  function refreshCart() { if (!document.querySelector('[data-rs-ship]')) return; fetch('/cart.js').then(function (r) { return r.json(); }).then(updateShip).catch(function () {}); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rs-ship-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true; b.textContent = 'Tilføjer…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.dataset.rsShipAdd, 10), quantity: 1 }] }) })
      .then(function () {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rs-ship' });
        var drawer = document.querySelector('cart-drawer');
        if (location.pathname === '/cart' || drawer && drawer.classList.contains('active')) { location.reload(); } else { refreshCart(); }
      }).catch(function () { b.disabled = false; });
  });
  refreshCart();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart); }
  document.addEventListener('cart:updated', refreshCart);

  // Optional 1 mm drill bit (PDP checkbox): added just before the spikes, so the cart drawer shows both
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || f.dataset.rsDrillDone) return;
    var cb = document.querySelector('[data-rs-drill]');
    if (!cb || !cb.checked) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var go = function () { f.dataset.rsDrillDone = '1'; if (f.requestSubmit) { f.requestSubmit(); } else { f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } delete f.dataset.rsDrillDone; };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(cb.value, 10), quantity: 1 }] }) })
      .then(function () { cb.checked = false; go(); }).catch(go);
  }, true);

  // Sticky add to cart on mobile
  var sticky = document.querySelector('[data-rs-sticky]');
  var form = document.querySelector('product-form form[action*="/cart/add"]');
  if (sticky && form && 'IntersectionObserver' in window) {
    var btn = form.querySelector('[type=submit]');
    new IntersectionObserver(function (e) { sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(btn || form);
    sticky.querySelector('[data-rs-sticky-btn]').addEventListener('click', function () { if (btn && !btn.disabled) { btn.click(); } else { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
  }
})();
